/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Modal, Tooltip, Skeleton, Spin, Badge } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  PrinterFilled,
  BarcodeOutlined,
} from "@ant-design/icons";
import "./index.css";
import { useHistory } from "react-router";
import moment from "moment";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  // deletePurchaseInvoiceList,
  loadPurchaseBarcode,
  loadPurchaseInvoice,
  loadPurchasePrintReceipt,
  // loadPurchasePrintReceipt,
} from "../../store/purchase-invoice/actions";
// import { ledgerStatementList } from "./data";
import html2canvas from "html2canvas";
// import { BsCashCoin } from "react-icons/bs";
import { ToWords } from "to-words";
import jsPDF from "jspdf";
// import ReactToPrint from "react-to-print-advanced";
import { useReactToPrint } from "react-to-print";
import Barcode from "react-barcode";
import useMedia from "use-media-antd-query";
import api from "../../helpers";

const PurchaseInvoiceSelection = (props) => {
  const [loading, setLoading] = useState(false);
  const [purchasePrint, setPurchasePrint] = useState(false);
  const [barcodePrint, setBarcodePrint] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const media = useMedia();
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const organisationName = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationName
    : "";
  // const userInfoMobile = !isEmpty(userNameDetails)
  //   ? userNameDetails.user.mobileNo
  //   : "";
  const purchaseListId = { organizationId: userInfoDetails };

  //partys tabs

  //Props values from parties home

  const itemList =
    props.location && props.location.state ? props.location.state.itemLi : "";

  const organizationId = props.location.state
    ? props.location.state.organizationId
    : "";
  const userId = props.location.state ? props.location.state.userId : "";

  const purchaseInvoiceExistingData =
    props.location && props.location.state
      ? props.location.state.purchaseInvoice
      : "";
  const purchaseId = purchaseInvoiceExistingData
    ? purchaseInvoiceExistingData._id
    : "";

  const billStatus =
    purchaseInvoiceExistingData &&
    purchaseInvoiceExistingData.billStatus &&
    purchaseInvoiceExistingData.billStatus.length > 0
      ? purchaseInvoiceExistingData.billStatus[0].billStatusNo
      : "";
  const billStatusName =
    purchaseInvoiceExistingData &&
    purchaseInvoiceExistingData.billStatus &&
    purchaseInvoiceExistingData.billStatus.length > 0
      ? purchaseInvoiceExistingData.billStatus[0].statusName
      : "";

  //api loader
  useEffect(() => {
    dispatch(loadPurchaseInvoice(purchaseListId));
    dispatch(
      loadPurchasePrintReceipt({
        organizationId: userInfoDetails,
        purchaseInvoiceId: purchaseId,
      })
    );
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);

    // const detectDevTools = () => {
    //   const threshold = 160; // Adjust based on browser behavior
    //   const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    //   const heightThreshold =
    //     window.outerHeight - window.innerHeight > threshold;

    //   setIsDevToolsOpen(widthThreshold || heightThreshold);
    // };

    // const interval = setInterval(detectDevTools, 500); // Check every 500ms
    // return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { purchase_barcode_list = [], purchase_print_receipt = [] } =
    useSelector((state) => state.PurchaseInvoice);

  const purchaseInvoiceData =
    !isEmpty(purchase_print_receipt) && purchase_print_receipt
      ? purchase_print_receipt
      : "";

  const vendorAddress =
    purchaseInvoiceExistingData &&
    purchaseInvoiceExistingData.vendorAddress &&
    purchaseInvoiceExistingData.vendorAddress.length > 0
      ? purchaseInvoiceExistingData.vendorAddress[0]
      : "";

  const [pageRouting, setPageRouting] = useState(false);
  const history = useHistory();

  //category api integrations
  const [deletePurchaseModal, setDeletePurchaseModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //deletPurchase api integrations
  const deletePurchaseInvoiceDetails = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemListData = {
      organizationId: userInfoDetails,
      piId: purchaseId,
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    api
      .post("/org/deletepurchaseinvoice", itemListData)
      .then((res) => {
        setTimeout(() => {
          dispatch(loadPurchaseInvoice(purchaseListId));
          setDeletePurchaseModal(false);
          setTimeout(() => {
            history.push("/purchase-invoice");
          }, 1000);
          toast.error("Purchase invoice deleted successfully");
        }, 1000);
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error);
        toast.error(errorMsg || "there is an issue while adding prefix");
        return Promise.reject(error);
      });
  };

  //Ledger statement section
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toWords = new ToWords();

  // const contentRef = useRef();
  const handleDownloadPDF = () => {
    // const input = document.getElementById("pdf-content");

    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
    }, 3000);
    const content = salesInvoiceRef.current;

    setTimeout(() => {
      html2canvas(content).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 195;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 8, 10, imgWidth, imgHeight);
        pdf.save("Purchase-invoice.pdf");
      });
    }, 1200);
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let quantityCount = 0;
    let totalAmount = 0;

    rows.forEach((row) => {
      quantityCount += parseFloat(row.qty) || 0;
      totalAmount += parseFloat(row.qtyTotal) || 0;
    });

    return { quantityCount, totalAmount };
  };

  const [totals, setTotals] = React.useState({
    quantityCount: 0,
    totalAmount: 0,
  });

  useEffect(() => {
    if (
      !isEmpty(purchase_print_receipt) &&
      purchase_print_receipt.items.length > 0
    ) {
      const total = calculateTotals(purchase_print_receipt.items);
      setTotals(total);
    }
  }, [purchase_print_receipt]);

  const netTotalAmount =
    purchaseInvoiceExistingData.autoroundoffamount !== undefined &&
    purchaseInvoiceExistingData.isautoroundoffadd == true
      ? parseFloat(
          purchaseInvoiceExistingData.autoroundoffamount +
            purchaseInvoiceData.totalPrice
        )
      : purchaseInvoiceExistingData.autoroundoffamount !== undefined &&
        purchaseInvoiceExistingData.isautoroundoffreduce == true
      ? parseFloat(
          purchaseInvoiceData.totalPrice -
            purchaseInvoiceExistingData.autoroundoffamount
        )
      : purchaseInvoiceData.totalPrice;

  const netAmount =
    purchaseInvoiceData.autoroundoffamount !== undefined &&
    purchaseInvoiceData &&
    purchaseInvoiceData.totalPrice
      ? purchaseInvoiceData.totalPrice.toLocaleString("en-IN")
      : netTotalAmount !== undefined
      ? parseFloat(netTotalAmount.toFixed(2)).toLocaleString("ens-IN")
      : 0;
  const netAmountWords =
    purchaseInvoiceData.autoroundoffamount !== undefined &&
    purchaseInvoiceData &&
    purchaseInvoiceData.totalPrice
      ? purchaseInvoiceData.totalPrice
      : netTotalAmount !== undefined
      ? parseFloat(netTotalAmount)
      : 0;

  const salesInvoiceRef = useRef(null);
  const barcodeRef = useRef(null);

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handlePrint = useReactToPrint({
    pageStyle: `@media print {
      @page {
        margin: 13px;
      }
    }`,
    contentRef: salesInvoiceRef, // Specify the element to be printed
    // documentTitle: 'My Printed Document', // You can set a custom document title for the print
    // onBeforeGetContent: () => console.log('Preparing to print...'), // Optional: Perform any actions before print
    // onAfterPrint: () => console.log('Printing completed!'), // Optional: Perform any actions after print
  });
  // const handleBarcode = useReactToPrint({
  //   // pageStyle: `@media print {
  //   //   @page {
  //   //    pageStyle: '{ size: 2.5in 4in }'

  //   //     background: none;
  //   //     margin: 0;
  //   //   }
  //   // }`,
  //   pageStyle: "{ size: 47mm 25mm }",
  //   // contentRef: barcodeRef, // Specify the element to be printed
  //   // documentTitle: "", // You can set a custom document title for the print
  //   // onBeforeGetContent: () => console.log('Preparing to print...'), // Optional: Perform any actions before print
  //   // removeAfterPrint: true, // Ensures the page remains normal after print
  // });

  // const handleBarcodePrint = () => {
  //   const opt = { scale: 4 };

  //   // Select all barcode elements
  //   const barcodeElements = document.querySelectorAll(".barcode-page");
  //   //  const elem = barcodeRef.current;
  //   const element = barcodeElements != null && barcodeElements;
  //   setTimeout(() => {
  //     const promises = Array.from(element).map((elem) =>
  //       html2canvas(elem, opt).then((canvas) =>
  //         canvas.toDataURL("image/png", 2.0)
  //       )
  //     );

  //     Promise.all(promises).then((allImages) => {
  //       const iframe = document.createElement("iframe");
  //       iframe.name = "printf";
  //       iframe.style.position = "absolute";
  //       iframe.style.width = "0px";
  //       iframe.style.height = "0px";
  //       iframe.style.visibility = "hidden";
  //       document.body.appendChild(iframe);

  //       const printStyle = `
  //       <style>
  //           @page {
  //               size: 47mm 24mm; /* Correct page size */
  //               margin: 0;
  //           }
  //           body {
  //               margin: 0;
  //               padding: 0;
  //               display: flex;
  //               flex-direction: column;
  //               align-items: center;
  //               justify-content: center;
  //           }
  //           .barcode-container {
  //               width: 47mm;
  //               height: 24mm;
  //               display: flex;
  //               align-items: center;
  //               justify-content: center;
  //               page-break-before: always;
  //           }
  //           .barcode-container img {
  //               width: 100%;
  //               height: 100%;
  //               object-fit: contain;
  //           }
  //       </style>
  //       `;

  //       // Generate HTML content with images
  //       const content = allImages
  //         .map(
  //           (imgUrl) =>
  //             `<div class="barcode-container"><img src="${imgUrl}" /></div>`
  //         )
  //         .join("");

  //       // Write to iframe
  //       const newWin = iframe.contentWindow;
  //       newWin.document.open();
  //       newWin.document.write(`${printStyle}<body>${content}</body>`);
  //       newWin.document.close();

  //       // Wait for images to load before printing
  //       setTimeout(() => {
  //         newWin.focus();
  //         newWin.print();
  //         setTimeout(() => document.body.removeChild(iframe), 1000);
  //       }, 1000);
  //     });
  //   }, 3000);
  // };

  const handleBarcodePrint = () => {
    const opt = {
      scale: 3,
    };
    const elem = barcodeRef.current;
    const element = elem != null && elem;
    setTimeout(() => {
      html2canvas(element, opt).then((canvas) => {
        const iframe = document.createElement("iframe");
        iframe.name = "printf";
        iframe.id = "printf";
        iframe.height = "24mm";
        iframe.width = "47mm";
        document.body.appendChild(iframe);

        const imgUrl = canvas.toDataURL({
          format: "jpeg",
          quality: "1.5",
        });

        // const style = `
        //      height: 100vh;
        //      width: 100vw;
        //      position:absolute;
        //      left:0:
        //      top:0;
        //  `;

        const printStyle = `
         <style>
             @page {
              size: 47mm 24mm /*  ; Custom Page Size */
              margin: 0 50px;
             }
             body {
              width: 5%;
              height: 5vh;
              margin: 1;
             }
             .barcode-page {
               page-break-after: always;
             }
            .barcode-page:last-child {
               page-break-after: auto;
            }
         </style>
     `;
        // size: 100mm 50mm;
        // position: absolute;
        //       left: 0;
        //       top: 0;

        const url = `<img src="${imgUrl}"/>`;
        var newWin = window.frames["printf"];
        newWin.document.write(
          `${printStyle}<body onload="window.print()">${url}</body>`
        );
        newWin.document.close();
      });
    }, 2000);
  };
  //totals
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Purchase Invoice | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Row>
                <Col
                  span={24}
                  className="bg-[#ffffff] border border-b-1 border-x-0 border-t-0 pb-2"
                >
                  <div
                    className={
                      media === "sm" || media === "xs"
                        ? "font-poppins flex flex-col pl-[20px] pr-[20px] mt-2"
                        : "font-poppins flex justify-between pl-[20px] pr-[20px] mt-2"
                    }
                  >
                    <div className="flex">
                      <ArrowLeftOutlined
                        onClick={() => setPageRouting(true)}
                        className="font-bold text-[18px]"
                      />
                      <h1
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className={
                          media === "sm" || media === "xs"
                            ? "text-[16px] ml-2 mt-1 font-semibold"
                            : "text-[18px] ml-2 mt-1 font-semibold"
                        }
                      >
                        {"Purchase Invoice "}
                        {purchaseInvoiceExistingData &&
                        purchaseInvoiceExistingData.prefixName
                          ? purchaseInvoiceExistingData.prefixName +
                            "" +
                            purchaseInvoiceExistingData.purchaseinvoiceNo
                          : purchaseInvoiceExistingData.purchaseinvoiceNo
                          ? purchaseInvoiceExistingData.purchaseinvoiceNo
                          : ""}
                      </h1>
                      <Badge
                        className={
                          billStatus === 1
                            ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] h-[30px] mt-1 p-2 ml-4"
                            : billStatus === 3
                            ? "bg-[#ebc951e0] font-semibold rounded-md text-[white] h-[30px] mt-1 p-2 ml-4"
                            : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] h-[30px] mt-1 p-2 ml-4"
                        }
                      >
                        {billStatusName}
                      </Badge>
                    </div>

                    <div
                      className={
                        media === "sm" || media === "xs" ? "flex mt-2" : "flex"
                      }
                    >
                      <Tooltip
                        title="Edit Purchase Invoice"
                        placement="left"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => {
                            history.push({
                              pathname: "/create-purchase-invoice",
                              state: {
                                purchaseInvoiceData:
                                  purchaseInvoiceExistingData &&
                                  purchaseInvoiceExistingData,
                                organizationId: organizationId,
                                userId: userId,
                                itemList: itemList,
                              },
                            });
                          }}
                          className="border flex rounded-md justify-between  pl-3 pr-1 pt-1 pb-1 ml-3  cursor-pointer"
                        >
                          <EditOutlined className="text-[18px] pr-3" />
                          {media === "sm" || media === "xs" ? (
                            <p
                              style={{
                                fontFamily: "Poppins",
                                paddingLeft: "2px",
                              }}
                            >
                              Edit
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="Delete This Purchase"
                        placement="bottom"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => setDeletePurchaseModal(true)}
                          className="border border-1 flex border-red-200 text-[red] rounded-md ml-3 pl-3 pr-3 pt-1 pb-1 cursor-pointer"
                        >
                          <DeleteOutlined />
                          {media === "sm" || media === "xs" ? (
                            <p
                              style={{
                                fontFamily: "Poppins",
                                paddingLeft: "4px",
                              }}
                            >
                              Delete
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </Col>

                <Col span={24} className="pl-4 pt-4 pb-4 pr-1 bg-[#ffffff]">
                  <Row>
                    <Col span={20}>
                      <Row>
                        <Col md={8} lg={6} sm={24} xs={24} className="pr-3">
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              style={{
                                fontFamily: "Poppins",
                              }}
                              onClick={handleDownloadPDF}
                              className="cursor-pointer flex border flex justify-center pt-2 pb-2 pl-2 pr-4 rounded-md border-1 track-wider text-start lg:text-center xl:text-center"
                            >
                              {downloadLoading ? (
                                <p className="flex">
                                  <Spin className="mr-2" /> Downloading
                                </p>
                              ) : (
                                <div className="flex">
                                  <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                  Download
                                </div>
                              )}
                            </div>
                          )}
                        </Col>
                        <Col
                          md={8}
                          lg={6}
                          sm={24}
                          xs={24}
                          className={
                            media === "xs" || media === "sm"
                              ? "pr-3 mt-2"
                              : "pr-3"
                          }
                        >
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              className="cursor-pointer w-[100%]"
                              onClick={() => {
                                setPurchasePrint(true);
                                setTimeout(() => {
                                  setPurchasePrint(false);
                                }, 4000);
                              }}
                            >
                              {/* <ReactToPrint */}
                              {/* // pageStyle={pageStyle} */}
                              {/* // pageStyle="@page { size: A4; margin: 5mm }" // Optional custom print styles */}
                              {/* // trigger={() => ( */}
                              <div
                                onClick={handlePrint}
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className=" track-wider flex border justify-center pt-2 pb-2 pl-2 pr-4 rounded-md border-1 text-start lg:text-center xl:text-center"
                              >
                                {purchasePrint ? (
                                  <p className="flex">
                                    <Spin className="mr-2" /> Loading
                                  </p>
                                ) : (
                                  <div className="flex">
                                    <PrinterFilled className="cursor-pointer text-[16px] mr-3" />
                                    Print Receipt
                                  </div>
                                )}
                              </div>
                              {/* )}
                                delay={1500}
                                content={() => salesInvoiceRef.current}
                              /> */}
                            </div>
                          )}
                        </Col>
                        <Col
                          md={8}
                          lg={6}
                          sm={24}
                          xs={24}
                          className={
                            media === "xs" || media === "sm"
                              ? "pr-3 mt-2"
                              : "pr-3"
                          }
                        >
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              className="cursor-pointer w-[100%]"
                              onClick={() => {
                                setBarcodePrint(true);
                                dispatch(
                                  loadPurchaseBarcode({
                                    organizationId: userInfoDetails,
                                    purchaseInvoiceId: purchaseId,
                                  })
                                );
                                setTimeout(() => {
                                  setBarcodePrint(false);
                                }, 4000);
                              }}
                            >
                              {/* <ReactToPrint
                                // pageStyle="@page { background: none; margin: 0; padding: 2px; }" // Optional custom print styles
                                pageStyle="@page { size: 47mm 24mm; background: none; margin: 0; padding: 2px; }" // Optional custom print styles
                                trigger={() => ( */}
                              <div
                                onClick={() => handleBarcodePrint()}
                                // onClick={() => handleBarcode()}
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className=" track-wider flex border justify-center pt-2 pb-2 pl-2 pr-4 rounded-md  border-1 text-start lg:text-center xl:text-center"
                              >
                                {barcodePrint ? (
                                  <p className="flex">
                                    <Spin className="mr-2" /> Loading
                                  </p>
                                ) : (
                                  <div className="flex">
                                    <BarcodeOutlined className="cursor-pointer text-[16px] mr-3" />
                                    Print Barcode
                                  </div>
                                )}
                              </div>
                              {/* )}
                                delay={1500}
                                content={() => barcodeRef.current}
                              /> */}
                            </div>
                          )}
                        </Col>
                        {/* <Col md={7} lg={6} sm={12} xs={24}>
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div className="text-start">
                              <Popover
                                placement="bottomRight"
                                trigger={"click"}
                                content={ledgerStatementList}
                              >
                                <Tooltip
                                  title="Easily perform bulk actions on all your Parties"
                                  placement="left"
                                  rootClassName="text-[10px]"
                                >
                                  <div
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="border rounded-sm flex justify-between pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                                  >
                                    <div>
                                      <ShareAltOutlined className="mr-2" />
                                      Share
                                    </div>
                                    <DownOutlined />
                                  </div>
                                </Tooltip>
                              </Popover>
                            </div>
                          )}
                        </Col> */}
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col
                  span={24}
                  className={
                    (windowDimensions.height >= 700 &&
                      windowDimensions.height <= 767) ||
                    (windowDimensions.height > 767 &&
                      windowDimensions.height < 830)
                      ? "add-purchase-main-large-device mt-3"
                      : windowDimensions.height > 830 &&
                        windowDimensions.height < 900
                      ? "add-purchase-main-extra-large-device mt-3"
                      : windowDimensions.height > 900 &&
                        windowDimensions.height < 1000
                      ? "add-purchase-main-extra-extra-large-device mt-3"
                      : windowDimensions.height > 1000
                      ? "add-purchase-main-extra-infinite-device mt-3"
                      : "add-purchase-main mt-3"
                  }
                >
                  <Row className="flex justify-center">
                    <Col span={media === "xxl" ? 14 : 20} className="mb-4 pb-6">
                      <div
                        className={
                          downloadLoading
                            ? "rounded-sm bg-[#ffffff] pb-3 pl-8 pr-10 mb-3"
                            : "rounded-sm bg-[#ffffff] pb-3 pl-8 pr-8 mb-3"
                        }
                      >
                        <Row>
                          <Col span={24} className="pb-3 mt-5 ml-4">
                            <h1 className="text-[14px] font-semibold uppercase mt-2 party-label">
                              {purchaseInvoiceExistingData
                                ? purchaseInvoiceExistingData.transActionType
                                : ""}
                            </h1>
                          </Col>
                        </Row>
                        <Row
                          className={
                            purchasePrint
                              ? "flex bg-[#ffffff] justify-center ml-5 mr-5 mt-5 mb-4"
                              : !purchasePrint && downloadLoading
                              ? "flex bg-[#ffffff] justify-center ml-3 mr-4 mt-2 mb-4"
                              : "flex bg-[#ffffff] justify-center ml-3 mr-4 mt-2 mb-4"
                          }
                          style={{
                            border: "1px solid black",
                          }}
                          // id="pdf-content"
                          ref={salesInvoiceRef}
                        >
                          <Col
                            md={24}
                            className={
                              "pt-4 pb-4 border-solid rounded-sm bg-[#ffffff]"
                            }
                          >
                            <Row>
                              <Col span={24} className="pb-3 pt-3 text-center">
                                <div
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="w-[100%] p-2"
                                >
                                  <p className="party-label">
                                    <p className="text-[18px] text-center font-semibold capitalize">
                                      {/* {userOrganisationName
                                        ? userOrganisationName
                                        : ""} */}
                                      Purchase Estimate
                                    </p>
                                  </p>
                                  <p className="party-label">
                                    <p className="text-[13px] text-center font-semibold mr-2">
                                      Mobile:
                                    </p>
                                    <p className="text-[13px]">
                                      {purchaseInvoiceData
                                        ? purchaseInvoiceData.contactNo
                                        : ""}
                                    </p>
                                  </p>
                                </div>
                              </Col>
                              <Col
                                span={24}
                                style={{
                                  border: "1px solid black",
                                  borderLeft: "none",
                                  borderRight: "none",
                                  borderBottom: purchasePrint
                                    ? "1px solid black"
                                    : "1px solid black",
                                }}
                              >
                                <Row>
                                  <Col
                                    md={11}
                                    sm={24}
                                    lg={11}
                                    xs={24}
                                    style={{
                                      borderRight: purchasePrint
                                        ? ""
                                        : "1px solid black",
                                      borderBottom: purchasePrint
                                        ? "1px solid black"
                                        : "",
                                    }}
                                  >
                                    <div className="p-2 pt-3 pb-3">
                                      <h1 className="purchase-label text-[12px] font-semibold mr-3 uppercase">
                                        Bill From:
                                      </h1>
                                      <p className="mt-1 text-[14px] purchase-label font-semibold">
                                        {purchaseInvoiceExistingData
                                          ? purchaseInvoiceExistingData.vendorName
                                          : ""}
                                      </p>
                                      <p className="mt-1 text-[12px] purchase-label">
                                        Address:{" "}
                                        {vendorAddress
                                          ? vendorAddress.address1 +
                                            ", " +
                                            vendorAddress.city +
                                            ", " +
                                            "Tamil Nadu" +
                                            // vendorAddress.vendorStateName || "" +
                                            " - " +
                                            vendorAddress.pincode
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col
                                    md={13}
                                    sm={24}
                                    lg={13}
                                    xs={24}
                                    style={{
                                      borderBottom: purchasePrint
                                        ? "1px solid black"
                                        : "",
                                    }}
                                  >
                                    <Row className="w-[100%] flex justify-between pl-8 pr-5 pt-5 pb-5">
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          Invoice No:
                                        </h1>
                                        <p className="mt-[-2px] purchase-label text-[13px]">
                                          {purchaseInvoiceExistingData &&
                                          purchaseInvoiceExistingData.prefixName
                                            ? purchaseInvoiceExistingData.prefixName +
                                              "" +
                                              purchaseInvoiceExistingData.purchaseinvoiceNo
                                            : purchaseInvoiceExistingData.purchaseinvoiceNo}
                                        </p>
                                      </div>
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          Invoice Date:
                                        </h1>
                                        <p className="mt-[-2px] purchase-label text-[13px]">
                                          {purchaseInvoiceExistingData.purchaseinvoiceDate
                                            ? moment(
                                                purchaseInvoiceExistingData.purchaseinvoiceDate
                                              ).format("DD/MM/YYYY")
                                            : ""}
                                        </p>
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>

                              {/* PO statement */}
                              <Col span={24} className="add-create-item-table">
                                <table className="mb-[3.5rem] table-purchase-serial table-responsive">
                                  <thead>
                                    <tr className="table-activities-head-main">
                                      <th className="w-[5%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        S.No
                                      </th>
                                      <th className="w-[18%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Brand
                                      </th>
                                      <th className="w-[17%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Model Name
                                      </th>
                                      {/* <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        IMEI
                                      </th>
                                      <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        RAM
                                      </th> */}
                                      <th className="w-[11%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Rate
                                      </th>
                                      <th className="w-[9%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Qty
                                      </th>
                                      <th className="w-[11%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Tax
                                      </th>
                                      <th className="w-[9%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Discount
                                      </th>
                                      <th className="w-[20%] uppercase text-end table-sales-invoice-print-main-head text-[12px] font-semibold">
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="mb-8">
                                    {purchaseInvoiceData &&
                                    purchaseInvoiceData.items &&
                                    purchaseInvoiceData.items.length > 0
                                      ? purchaseInvoiceData.items.map(
                                          (data, index) => {
                                            // const serialDetails =
                                            //   data.serialDetails &&
                                            //   data.serialDetails.length > 0
                                            //     ? data.serialDetails[0]
                                            //     : "";
                                            // const totalAmount =
                                            //   data && data.qty
                                            //     ? parseInt(
                                            //         data.qty *
                                            //           data.purchasePrice
                                            //       )
                                            //     : data.purchasePrice;
                                            return (
                                              <tr
                                                key={index}
                                                className={
                                                  "table-purchase-row border border-b-1 border-x-0 border-t-0"
                                                }
                                              >
                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {index + 1}
                                                </td>
                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {data.brandName}
                                                </td>
                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {data.modelName}
                                                </td>
                                                {/* <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {serialDetails
                                                    ? serialDetails.IMEI
                                                    : ""}
                                                </td> */}
                                                {/* <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {serialDetails
                                                    ? serialDetails.ramName
                                                    : ""}
                                                </td> */}

                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2 text-end"
                                                  }
                                                >
                                                  {data && data.purchasePrice
                                                    ? parseFloat(
                                                        data.purchasePrice
                                                      )
                                                        .toFixed(2)
                                                        .toLocaleString("en-IN")
                                                    : ""}
                                                </td>
                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2 text-end"
                                                  }
                                                >
                                                  {data.qty
                                                    ? data.qty + " PCS"
                                                    : 0 + " PCS"}
                                                </td>
                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2 text-end"
                                                  }
                                                >
                                                  <div className="flex justify-end">
                                                    <p>
                                                      {data && data.tax
                                                        ? parseFloat(data.tax)
                                                            .toFixed(2)
                                                            .toLocaleString(
                                                              "en-IN"
                                                            )
                                                        : ""}
                                                    </p>
                                                    <p className="ml-1">
                                                      {data.taxPercentage ? (
                                                        <p>
                                                          ({data.taxPercentage})
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </p>
                                                  </div>
                                                </td>
                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-activities-purchase-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-activities-purchase-data p-2 text-end"
                                                  }
                                                >
                                                  {data && data.discount
                                                    ? data.discount.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    : data && data.discount == 0
                                                    ? 0
                                                    : ""}
                                                </td>
                                                <td
                                                  className={
                                                    downloadLoading
                                                      ? "table-sales-invoice-print-data pt-2 pb-2 pr-1 pl-1 text-end"
                                                      : "table-sales-invoice-print-data p-2 text-end"
                                                  }
                                                >
                                                  {data && data.qtyTotal
                                                    ? data.qtyTotal.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    : ""}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      : ""}
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        borderRight: "none",
                                      }}
                                      className="font-semibold"
                                    >
                                      <td
                                        className="p-[70px] uppercase font-semibold text-[14px]"
                                        colSpan={8}
                                      >
                                        {""}
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        // backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                        colSpan={1}
                                        className="table-activities-purchase-total-head p-2 text-end"
                                      ></td>
                                      <td
                                        colSpan={3}
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                      >
                                        {"Total"}
                                      </td>
                                      <td
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        colSpan={1}
                                      >
                                        {purchaseInvoiceData &&
                                        purchaseInvoiceData.totalQty
                                          ? purchaseInvoiceData.totalQty
                                          : ""}
                                      </td>
                                      <td
                                        className={
                                          purchasePrint
                                            ? "text-start table-activities-purchase-total-head uppercase p-1 font-semibold"
                                            : "text-start table-activities-purchase-total-head uppercase p-2 font-semibold"
                                        }
                                        colSpan={1}
                                      >
                                        <p className="">
                                          {purchaseInvoiceData &&
                                          purchaseInvoiceData.totalTax
                                            ? "₹ " +
                                              parseFloat(
                                                purchaseInvoiceData.totalTax
                                              )
                                                .toFixed(2)
                                                .toLocaleString("en-IN")
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                      <td
                                        className="text-end table-activities-purchase-total-head uppercase p-2 font-semibold"
                                        colSpan={1}
                                      >
                                        <p className="">
                                          {purchaseInvoiceData &&
                                          purchaseInvoiceData.totalDiscount
                                            ? "₹ " +
                                              purchaseInvoiceData.totalDiscount.toLocaleString(
                                                "en-IN"
                                              )
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                      <td className="table-activities-purchase-invoice-total-head p-2 text-end">
                                        <p className="">
                                          {purchaseInvoiceData &&
                                          purchaseInvoiceData.totalPrice
                                            ? "₹ " +
                                              totals.totalAmount.toLocaleString(
                                                "en-IN"
                                              )
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        // backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                        colSpan={1}
                                        className="table-activities-purchase-total-head p-2 text-end"
                                      ></td>
                                      <td
                                        colSpan={3}
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                      >
                                        {"Round off Value"}
                                      </td>
                                      <td
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        colSpan={1}
                                      ></td>

                                      <td
                                        colSpan={3}
                                        className="table-activities-purchase-invoice-total-head p-2 text-end"
                                      >
                                        <div className="flex justify-end">
                                          <p>
                                            {purchaseInvoiceExistingData.isautoroundoffadd &&
                                            purchaseInvoiceExistingData.isautoroundoffadd ==
                                              true
                                              ? "(+)"
                                              : purchaseInvoiceExistingData.isautoroundoffreduce &&
                                                purchaseInvoiceExistingData.isautoroundoffreduce ==
                                                  true
                                              ? "(-)"
                                              : ""}
                                          </p>

                                          <p className="ml-1">
                                            {purchaseInvoiceExistingData &&
                                            purchaseInvoiceExistingData.autoroundoffamount
                                              ? "₹ " +
                                                purchaseInvoiceExistingData.autoroundoffamount.toLocaleString(
                                                  "en-IN"
                                                )
                                              : "₹ " + 0}
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        // backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                        colSpan={1}
                                        className="table-activities-purchase-total-head p-2 text-end"
                                      ></td>
                                      <td
                                        colSpan={3}
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                      >
                                        {"Overall Discount"}
                                      </td>
                                      <td
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        colSpan={1}
                                      ></td>

                                      <td
                                        colSpan={3}
                                        className="table-activities-purchase-invoice-total-head p-2 text-end"
                                      >
                                        <p className="">
                                          {purchaseInvoiceData &&
                                          purchaseInvoiceData.overallDiscount
                                            ? "₹ " +
                                              purchaseInvoiceData.overallDiscount.toLocaleString(
                                                "en-IN"
                                              )
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderBottom: "1px solid black",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                        colSpan={1}
                                        className="table-activities-purchase-total-head p-2 text-end"
                                      ></td>
                                      <td
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                        colSpan={3}
                                        className="text-[13px] uppercase font-semibold table-activities-purchase-total-head p-2 text-end"
                                      >
                                        {"Net Amount"}
                                      </td>
                                      <td
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                        colSpan={1}
                                        className=" table-activities-purchase-total-head p-2 text-end"
                                      ></td>

                                      <td
                                        colSpan={3}
                                        className="w-[20%] table-activities-purchase-invoice-total-head p-2 text-end"
                                      >
                                        <p className="">{"₹ " + netAmount}</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <Row className="">
                                  <Col
                                    md={24}
                                    style={{
                                      width: purchasePrint ? "100%" : "",
                                      borderBottom: purchasePrint
                                        ? "1px solid black"
                                        : "",
                                      padding: "10px",
                                    }}
                                  >
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-start text-[14px]">
                                        Total Amount (in words)
                                      </h1>
                                      <h1 className="mt-1 font-medium text-[12px] text-start">
                                        {purchaseInvoiceData &&
                                        purchaseInvoiceData.totalPrice
                                          ? toWords.convert(netAmountWords, {
                                              currency: true,
                                              ignoreDecimal: true,
                                            })
                                          : ""}
                                      </h1>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={24} className="p-2">
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-[14px]">
                                        Terms and Conditions
                                      </h1>
                                      <p className="text-[12px]">
                                        {purchaseInvoiceExistingData
                                          ? purchaseInvoiceExistingData.termsandconditions
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col md={24} className="p-2">
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-[14px]">
                                        Notes
                                      </h1>
                                      <p className="text-[12px]">
                                        {purchaseInvoiceExistingData
                                          ? purchaseInvoiceExistingData.notes
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    {/* <Col
                      span={3}
                      style={{
                        position: "fixed",
                        top: 214,
                        right: 20,
                      }}
                      className="mb-4 pb-6 ml-[50px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="cursor-pointer border rounded-sm bg-[#ffffff] border-1 flex p-2"
                      >
                        <BsCashCoin className="pr-2" size={22} />
                        Profit Details
                      </div>
                    </Col> */}
                  </Row>
                  <Row className="border border-b-1 border-t-0 border-x-0 flex justify-center mt-3 mb-3"></Row>
                </Col>
                {/* {barcodePrint === true ? ( */}
                <Col
                  span={24}
                  className="pt-5 pr-4 pl-4"
                  // style={{
                  //   display: barcodePrint === true ? "none" : "none",
                  // }}
                  // id="barcode"
                >
                  <Row
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    ref={barcodeRef}
                  >
                    {purchase_barcode_list && purchase_barcode_list.length > 0
                      ? purchase_barcode_list.map((data, index) => {
                          return (
                            <div
                              // md={12}
                              key={index}
                              className={
                                windowDimensions.width > 1540 &&
                                windowDimensions.width < 1700
                                  ? "w-[12.7%] ml-[90px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : windowDimensions.width >= 1700 &&
                                    windowDimensions.width < 1850
                                  ? "w-[12.2%] ml-[70px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : windowDimensions.width >= 1850 &&
                                    windowDimensions.width < 2000
                                  ? "w-[10.5%] ml-[70px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : windowDimensions.width > 2000
                                  ? "w-[9.7%] ml-[70px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : media == "xl"
                                  ? "w-[15.5%] ml-[90px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : media == "lg"
                                  ? "w-[20%] ml-[60px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : windowDimensions.width >= 890 &&
                                    windowDimensions.width < 991
                                  ? "w-[21%] ml-[70px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : windowDimensions.width > 820 &&
                                    windowDimensions.width < 890
                                  ? "w-[23%] ml-[70px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : windowDimensions.width > 767 &&
                                    windowDimensions.width < 820
                                  ? "w-[25%] ml-[70px] rounded-md mb-2 mt-[15px] barcode-page"
                                  : "w-[18%] ml-[100px] rounded-md mb-2 mt-[15px] barcode-page"
                              }
                              // className="rounded-md mb-2 mt-2 barcode-page"
                              style={{
                                border: "1.5px solid black",
                              }}
                            >
                              <div className="pt-1 pr-1 pl-2">
                                <h1 className="text-[10px] mt-[-3px] text-center font-semibold uppercase barcode-label">
                                  {organisationName}:
                                </h1>
                                <div
                                  className={
                                    data.ramName
                                      ? "mb-[1px] flex justify-between font-semibold uppercase barcode-label"
                                      : "mb-[1px] flex justify-center font-semibold uppercase barcode-label"
                                  }
                                >
                                  <h1 className="text-[10px]">
                                    {data.modelName}
                                  </h1>
                                  {data.ramName ? (
                                    <p className="ml-[-12px] text-[10px]">
                                      {data.ramName}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="font-semibold barcode-label">
                                  <Barcode
                                    value={data.barCodeNo}
                                    // value={"spS" + data.barCodeNo}
                                    // width={2}
                                    fontSize={11}
                                    format="CODE128A"
                                    height={22}
                                    width={1.5}
                                    background="none"
                                    marginLeft={-7}
                                    // width={4.4}
                                    // marginLeft={5}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : ""}
                  </Row>
                </Col>
                {/* ) : (
                  ""
                )} */}
              </Row>
            </Col>

            {/* Parties input section with bulk actions */}
          </Row>
        </Col>
      </Row>

      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/purchase-invoice");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      {/* Delete purchase modal */}

      <Modal
        open={deletePurchaseModal}
        onOk={() => {
          deletePurchaseInvoiceDetails();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Purchase Invoice`}
        cancelText={"Cancel"}
        okType="danger"
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        onCancel={() => setDeletePurchaseModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-4">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these purchase?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected purchase will be deleted from the purchase Inventory.
            Once deleted you will not be able to restore these purchase.
          </p>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="colored"
      />
    </React.Fragment>
  );
};

PurchaseInvoiceSelection.propTypes = {
  location: PropTypes.any,
};

export default PurchaseInvoiceSelection;
